import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function WhyFailedSection() {
  const reasons = ["Porque te pedía 'disciplina' cuando estabas drenado.", 'Porque era extremo y te reventaba en 3 días.', 'Porque era inspiración sin estructura.', 'Porque te dejaba con culpa… y la culpa siempre termina en recaída.'];
  return <section className="py-12 px-4 bg-matrix-surface/30" data-id="element-316">
      <div className="max-w-3xl mx-auto" data-id="element-317">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-318">
          <h2 className="text-3xl md:text-4xl font-bold text-matrix-red mb-8" data-id="element-319">
            Por qué lo que intentaste antes falló
          </h2>

          <ul className="space-y-5 mb-10" data-id="element-320">
            {reasons.map((reason, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-4 text-lg text-matrix-muted" data-id="element-321">
                <XCircle className="w-6 h-6 text-matrix-red shrink-0 mt-1" data-id="element-322" />
                <span data-id="element-323">{reason}</span>
              </motion.li>)}
          </ul>

          <div className="bg-matrix-bg border border-matrix-red/30 p-8 rounded-lg relative overflow-hidden" data-id="element-324">
            <div className="absolute top-0 left-0 w-1 h-full bg-matrix-red" data-id="element-325" />
            <p className="text-xl text-matrix-text mb-4 font-medium" data-id="element-326">
              La Matrix ama que te insultes.
              <br data-id="element-327" />
              <span className="text-matrix-muted text-base font-normal" data-id="element-328">
                Porque un ser humano que se desprecia vuelve a anestesiarse.
              </span>
            </p>
            <p className="text-lg text-matrix-primary font-bold" data-id="element-329">
              Este protocolo hace lo contrario: te da un sistema para volver.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}